import React from 'react';

const Login = React.lazy(() => import('./App/pages/Login'));

const route = [
    { path: '/login', exact: true, name: 'ログイン', component: Login }
];

export default route;